import Vue from 'vue';
import VueSelectImage from 'vue-select-image';
import 'vue-select-image/dist/vue-select-image.css';

Vue.use(VueSelectImage);

export default VueSelectImage;



// WEBPACK FOOTER //
// ./node_modules/@triotech/vue-core/src/vendor/vue-select-image.js